import { CCY_POSITION, CCY_SCALE, CCY_SYMBOLS, type CcyCode } from './currencies.js';
import { D, MONEY_SCALE, type Money } from './decimal.js';

export function fmtAmt(value: Money | number, ccy: CcyCode): string {
  const n = typeof value === 'string' ? D(value).toNumber() : value;
  const symbol = CCY_SYMBOLS[ccy] ?? ccy;
  // Дробная часть — по точности валюты (CCY_SCALE), но не глубже MONEY_SCALE:
  // в БД хранится максимум 4 знака, показывать больше бессмысленно.
  // Фиат (scale 2) → центы; USDT (scale 8) → 4 знака, сотые доли цента не теряются.
  const maxDigits = Math.min(CCY_SCALE[ccy] ?? 2, MONEY_SCALE);
  const formatted = Math.abs(n).toLocaleString('ru-RU', { maximumFractionDigits: maxDigits });
  const sign = n < 0 ? '-' : '';
  if (CCY_POSITION[ccy] === 'after') return `${sign}${formatted} ${symbol}`;
  return `${sign}${symbol}${formatted}`;
}
